import { useEffect, useRef } from "react";
import { useNotification } from "../NotificationContext";
import { useDataProvider } from "react-admin";
import moment from "moment";

export const useBirthdaysNotifications = () => {
  const dataProvider = useDataProvider();
  const { addNotification, clearNotifications } = useNotification();
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (hasRunRef.current) return;
    hasRunRef.current = true;

    const fetchAllCustomers = async (providerId) => {
      const perPage = 1000;
      let page = 1;
      let allData = [];
      let keepFetching = true;

      while (keepFetching) {
        const { data, total } = await dataProvider.getList("enterprise/customers", {
          pagination: { page, perPage },
          sort: { field: "birthdate", order: "ASC" },
          filter: { providerId },
        });

        allData = [...allData, ...data];
        page++;
        if (allData.length >= total) {
          keepFetching = false;
        }
      }
      return allData;
    };

    const fetchBirthdays = async () => {
      const today = moment().format("YYYY-MM-DD");
      const stored = JSON.parse(localStorage.getItem("birthdaysShown") || "{}");

      if (stored.date === today && stored.ids?.length > 0) return;

      const profile = JSON.parse(localStorage.getItem("profile"));
      const providerId = profile?.role === "admin-sucursal" ? profile?.employer?._id : profile?._id;

      try {
        const data = await fetchAllCustomers(providerId);

        const updatedIds = [];
        let hasNewNotifications = false;

        data.forEach((customer) => {
          if (!customer.birthdate) return;

          const birthdate = moment.utc(customer.birthdate);
          const today = moment();
          const tomorrow = moment().add(1, "day");

          const birthdayThisYear = moment().month(birthdate.month()).date(birthdate.date());

          const isToday = birthdayThisYear.isSame(today, "day");
          const isTomorrow = birthdayThisYear.isSame(tomorrow, "day");

          if (isToday || isTomorrow) {
            const id = `birthday-${customer.id}-${isToday ? "today" : "tomorrow"}`;
            const idByName = `birthday-${customer.fullName}-${isToday ? "today" : "tomorrow"}`;

            if (!stored.ids?.includes(id) && !stored.ids?.includes(idByName)) {
              addNotification({
                id,
                title: "🎉 Cumpleaños",
                message: `${isToday ? "Hoy" : "Mañana"} cumple años ${customer.fullName}`,
              });
              updatedIds.push(id);
              hasNewNotifications = true;
            }
          }
        });

        if (hasNewNotifications) {
          clearNotifications();
          localStorage.setItem("birthdaysShown", JSON.stringify({ date: today, ids: updatedIds }));
        }
      } catch (error) {
        console.error("Error al obtener clientes:", error);
      }
    };

    fetchBirthdays();
  }, [dataProvider, addNotification, clearNotifications]);
};
